import { Link } from 'react-router-dom';
import { applications } from '@/mocks/applications';

export default function ApplicationsSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="mb-10 md:mb-14">
          <span className="text-primary-500 text-xs uppercase tracking-widest mb-2 block">Onde Utilizar</span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 uppercase leading-tight">Principais Aplicações</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-md">Nossas máquinas atendem projetos de impermeabilização em diversos setores no Brasil.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {applications.map((app) => (
            <Link
              key={app.id}
              to={`/aplicacoes/${app.id}`}
              className="group relative rounded-2xl overflow-hidden h-56 md:h-64 flex items-end cursor-pointer"
            >
              <img
                alt={app.title}
                className="absolute inset-0 w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                src={app.image}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-900/20 to-transparent" />
              <div className="relative z-10 p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-bold text-white uppercase mb-1">{app.title}</h3>
                <p className="text-white/70 text-xs leading-relaxed line-clamp-2">{app.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}